import { motion } from 'framer-motion';

interface IconProps {
  color?: string;
  isDarkMode?: boolean;
  onClick?: () => void;
}

export const GoodIcon: React.FC<IconProps> = ({ color, onClick }) => {
  return (
    <motion.svg
      onClick={onClick}
      whileTap={{ scale: 0.8 }}
      initial={{ scale: 1 }}
      animate={{ scale: 1 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.09445 11.0865C2.08246 10.9484 2.0993 10.8094 2.14391 10.6782C2.18851 10.5469 2.25991 10.4264 2.35356 10.3243C2.44721 10.2221 2.56108 10.1405 2.68793 10.0847C2.81478 10.0289 2.95185 10 3.09045 10H4.99995C5.26516 10 5.51952 10.1054 5.70705 10.2929C5.89459 10.4804 5.99995 10.7348 5.99995 11V20.5C5.99995 20.7652 5.89459 21.0196 5.70705 21.2071C5.51952 21.3946 5.26516 21.5 4.99995 21.5H3.91695C3.66666 21.5001 3.42545 21.4063 3.24096 21.2371C3.05646 21.068 2.9421 20.8358 2.92045 20.5865L2.09445 11.0865ZM8.99995 10.6875C8.99995 10.2695 9.25995 9.8955 9.63745 9.7175C10.4619 9.3285 11.8664 8.547 12.4999 7.4905C13.3164 6.1285 13.4704 3.668 13.4954 3.1045C13.4989 3.0255 13.4969 2.9465 13.5074 2.8685C13.6429 1.892 15.5274 3.0325 16.2499 4.2385C16.6424 4.8925 16.6924 5.752 16.6514 6.4235C16.6069 7.1415 16.3964 7.835 16.1899 8.524L15.7499 9.9925H21.1784C21.3329 9.99249 21.4854 10.0283 21.6237 10.0971C21.762 10.1658 21.8826 10.2658 21.9758 10.3889C22.0691 10.5121 22.1325 10.6553 22.1612 10.8071C22.1898 10.9589 22.1829 11.1153 22.1409 11.264L19.4559 20.772C19.3967 20.9817 19.2705 21.1663 19.0967 21.2977C18.9229 21.4291 18.7109 21.5001 18.4929 21.5H9.99995C9.73473 21.5 9.48038 21.3946 9.29284 21.2071C9.1053 21.0196 8.99995 20.7652 8.99995 20.5V10.6875Z"
        fill={color}
        stroke="black"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </motion.svg>
  );
};

export const BadIcon: React.FC<IconProps> = ({ color, onClick }) => {
  return (
    <motion.svg
      onClick={onClick}
      whileTap={{ scale: 0.8 }}
      initial={{ scale: 1 }}
      animate={{ scale: 1 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.09 13.417C2.07851 13.5549 2.09578 13.6937 2.14071 13.8246C2.18563 13.9555 2.25724 14.0757 2.351 14.1775C2.44476 14.2793 2.55863 14.3605 2.68541 14.416C2.81218 14.4715 2.9491 14.5001 3.0875 14.5H5C5.26522 14.5 5.51957 14.3946 5.70711 14.2071C5.89464 14.0196 6 13.7652 6 13.5V3.5C6 3.23478 5.89464 2.98043 5.70711 2.79289C5.51957 2.60536 5.26522 2.5 5 2.5H3.92C3.66916 2.50001 3.42748 2.5943 3.2429 2.76415C3.05832 2.934 2.94432 3.16703 2.9235 3.417L2.09 13.417ZM9 13.313C9 13.7305 9.26 14.1045 9.6375 14.283C10.462 14.6715 11.8665 15.453 12.5 16.51C13.3165 17.8715 13.4705 20.332 13.4955 20.8955C13.499 20.9745 13.497 21.0535 13.5075 21.1315C13.643 22.108 15.5275 20.9675 16.25 19.7615C16.6425 19.1075 16.6925 18.248 16.6515 17.5765C16.607 16.859 16.3965 16.165 16.19 15.476L15.75 14.0075H21.1785C21.333 14.0075 21.4854 13.9717 21.6238 13.9029C21.7621 13.8342 21.8826 13.7342 21.9759 13.6111C22.0691 13.4879 22.1326 13.3447 22.1612 13.1929C22.1899 13.0411 22.1829 12.8847 22.141 12.736L19.456 3.228C19.3967 3.0183 19.2706 2.8337 19.0967 2.70229C18.9229 2.57088 18.7109 2.49985 18.493 2.5H10C9.73478 2.5 9.48043 2.60536 9.29289 2.79289C9.10536 2.98043 9 3.23478 9 3.5V13.313Z"
        fill={color}
        stroke="black"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </motion.svg>
  );
};

export const SearchIcon: React.FC = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.207 12.959L18.007 16.753L16.753 18.007L12.959 14.207C11.3664 15.4805 9.34665 16.0958 7.31456 15.9264C5.28247 15.7571 3.39239 14.816 2.03259 13.2965C0.672804 11.7769 -0.0534378 9.79431 0.00306619 7.75596C0.0595702 5.71761 0.894529 3.7783 2.33641 2.33641C3.7783 0.894529 5.71761 0.0595702 7.75596 0.00306619C9.79431 -0.0534378 11.7769 0.672804 13.2965 2.03259C14.816 3.39239 15.7571 5.28247 15.9264 7.31456C16.0958 9.34665 15.4805 11.3664 14.207 12.959ZM12.43 12.302C13.5693 11.1276 14.1981 9.55047 14.1795 7.91438C14.1609 6.27829 13.4963 4.71588 12.3306 3.56773C11.1649 2.41957 9.59259 1.77875 7.9564 1.78496C6.32022 1.79116 4.75282 2.44389 3.59585 3.60085C2.43889 4.75782 1.78616 6.32522 1.77996 7.9614C1.77375 9.59759 2.41457 11.1699 3.56273 12.3356C4.71088 13.5013 6.27329 14.1659 7.90938 14.1845C9.54547 14.2031 11.1226 13.5743 12.297 12.435L12.43 12.302Z"
        fill="white"
      />
    </svg>
  );
};

// /** 기능개선 요청 아이콘 (문서/자료 요청) */
// export const RequestDocumentIcon: React.FC<{ size?: number; color?: string }> = ({ size = 18, color = 'currentColor' }) => {
//   return (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//       <path d="M14 2V8H20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//       <path d="M12 11V17" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//       <path d="M9 14H15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//     </svg>
//   );
// };

export const GlobeIcon: React.FC<IconProps> = ({ color, isDarkMode = false, onClick }) => {
  const fillColor = isDarkMode ? "transparent" : "white";
  const strokeColor = isDarkMode ? "white" : "#0056b3";

  return (
    <motion.svg
      onClick={onClick}
      whileTap={{ scale: 0.8 }}
      initial={{ scale: 1 }}
      animate={{ scale: 1 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 채우기 */}
      <circle cx="12" cy="12" r="10" fill={fillColor}/>
      {/* 윤곽선 */}
      <circle cx="12" cy="12" r="10" stroke={strokeColor} strokeWidth="1.8"/>
      {/* 위도선 */}
      <ellipse cx="12" cy="12" rx="10" ry="4" stroke={strokeColor} strokeWidth="1.8" fill="none"/>
      {/* 경선 */}
      <path d="M12 2 C15 2 17 5 17 9 L17 15 C17 19 15 22 12 22 C9 22 7 19 7 15 L7 9 C7 5 9 2 12 2" stroke={strokeColor} strokeWidth="1.8" fill="none"/>
    </motion.svg>
  );
};